module.exports = __webpack_public_path__ + "img/cases03.6f26613e.png";